import { IThreeVariantXP } from '@faire/web-api--source/indigofair/settings/IThreeVariantXP';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment to test minor updates to the styling and spacing of the discovery and evaluate product tiles.
 * This is the first iteration of visual improvements to enhance the product tile presentation.
 */
export const PRODUCT_TILE_FIRST_ITERATION_250506 =
  'PRODUCT_TILE_FIRST_ITERATION_250506' as SettingConst<
    'PRODUCT_TILE_FIRST_ITERATION_250506',
    keyof typeof IThreeVariantXP.Bucket,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
  >;
